import React, { useCallback, useContext, useEffect, useState } from "react";
import { emitUpsellModalAction, emitUpsellModalImpression, } from "@catchoftheday/analytics";
import { CustomerContext } from "@catchoftheday/customer";
import { legacyEventBus, useEventBus } from "@catchoftheday/state";
import { generateOnePassUpsellUrl, isMembershipFreeTrialEligible, TRIGGER_ONEPASS_UPSELL_MODAL_EVENT, triggerOnePassLinkingModal, } from "../../../utilities";
import { UpsellModal } from "../../pure/UpsellModal";
export const UpsellModalContainer = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { data: customer } = useContext(CustomerContext);
    const { membership } = customer || {};
    const { linked } = membership || {};
    const isLoggedIn = !!customer;
    const isFreeTrialEligible = isMembershipFreeTrialEligible(customer);
    const showSecondaryCTA = !isLoggedIn || !linked;
    const eventHandler = () => {
        emitUpsellModalImpression();
        setIsOpen(true);
    };
    useEventBus(TRIGGER_ONEPASS_UPSELL_MODAL_EVENT, () => {
        eventHandler();
    });
    useEffect(() => {
        legacyEventBus?.on(TRIGGER_ONEPASS_UPSELL_MODAL_EVENT.type, eventHandler);
        return () => {
            legacyEventBus?.detach(TRIGGER_ONEPASS_UPSELL_MODAL_EVENT.type, eventHandler);
        };
    }, []);
    const onMainCTAClick = useCallback(() => {
        emitUpsellModalAction({
            label: isFreeTrialEligible ? "freeTrial" : "join",
        });
    }, [isFreeTrialEligible]);
    const onClose = useCallback(() => {
        emitUpsellModalAction({ label: "close" });
        setIsOpen(false);
    }, []);
    const onLoginClick = useCallback(() => {
        emitUpsellModalAction({ label: "login" });
    }, []);
    const onLinkClick = useCallback(() => {
        emitUpsellModalAction({ label: "link" });
        if (typeof window !== "undefined") {
            onClose();
            triggerOnePassLinkingModal({
                originalUrl: window.location.pathname,
            });
        }
    }, [onClose]);
    const onLearnMoreClick = useCallback(() => {
        emitUpsellModalAction({ label: "learnMore" });
    }, []);
    return (<UpsellModal isOpen={isOpen} isLoggedIn={isLoggedIn} isFreeTrialEligible={isFreeTrialEligible} mainCTAHref={generateOnePassUpsellUrl({
            url: typeof window !== "undefined" ? window.location.pathname : "/",
            cta: isFreeTrialEligible ? "start-free-trial" : "join",
        })} showSecondaryCTA={showSecondaryCTA} onClose={onClose} onLoginClick={onLoginClick} onMainCTAClick={onMainCTAClick} onLinkClick={onLinkClick} onLearnMoreClick={onLearnMoreClick}/>);
};
